import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  return <section className="py-20 bg-stone-900 text-white overflow-hidden" data-id="element-120">
      <div className="container mx-auto px-4" data-id="element-121">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-122">
          <div className="flex-1" data-id="element-123">
            <span className="inline-block text-green-400 font-bold tracking-wider text-sm uppercase mb-4" data-id="element-124">
              La Solución
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-125">
              Esto no es un recetario. <br data-id="element-126" />
              <span className="text-stone-400" data-id="element-127">Es un sistema.</span>
            </h2>
            <p className="text-xl text-stone-300 mb-8 leading-relaxed" data-id="element-128">
              Un sistema para que tu cena deje de ser un problema diario.
              Diseñado para la vida real, no para Instagram.
            </p>

            <div className="space-y-4" data-id="element-129">
              {['Menos delivery y gastos innecesarios', 'Menos estrés y carga mental', "Sin 'meal prep' perfecto ni complicado", 'Recetas latinas que sí saben a comida real'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-130">
                  <CheckCircle2 className="h-6 w-6 text-green-500 shrink-0" data-id="element-131" />
                  <span className="text-lg text-stone-200" data-id="element-132">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="flex-1 w-full" data-id="element-133">
            <div className="bg-stone-800 p-8 rounded-3xl border border-stone-700 relative" data-id="element-134">
              <div className="absolute -top-4 -right-4 bg-red-600 text-white px-4 py-2 rounded-lg font-bold transform rotate-3 shadow-lg" data-id="element-135">
                El resultado
              </div>
              <blockquote className="text-xl md:text-2xl font-medium text-stone-200 italic mb-6" data-id="element-136">
                "No pienses. Ejecuta."
              </blockquote>
              <p className="text-stone-400 mb-6" data-id="element-137">
                Combinamos un sistema 4×4, un calendario de 12 semanas y listas
                de súper organizadas para que tu única tarea sea seguir el plan.
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-stone-700" data-id="element-138">
                <div className="h-10 w-10 rounded-full bg-green-600 flex items-center justify-center font-bold" data-id="element-139">
                  LC
                </div>
                <div data-id="element-140">
                  <p className="font-bold text-white" data-id="element-141">Listo Pa' Cenar</p>
                  <p className="text-sm text-stone-400" data-id="element-142">Sistema probado</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}